var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-content',[_c('kt-panel',[_c('kt-panel-body',[(_vm.status !== 'loading')?_c('ivr-form',{attrs:{"form_data":_vm.form_data,"submit":_vm.submit}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }